export default class Button extends Core.Component {
  get disabled() {
    return this.el.disabled;
  }

  set disabled(disabled) {
    this.el.disabled = disabled;
  }

  get text() {
    return this.el.innerText;
  }

  set text(text) {
    this.el.innerText = text;
  }

  setAttribute(attribute, value) {
    this.el.setAttribute(attribute, value);
  }

  getAttribute(attribute) {
    this.el.getAttribute(attribute);
  }

  hasAttribute(attribute) {
    this.el.hasAttribute(attribute);
  }

  removeAttribute(attribute) {
    this.el.removeAttribute(attribute);
  }
}
